import { render } from "./ClearAllStoreItems.vue?vue&type=template&id=64884da8&scoped=true"
import script from "./ClearAllStoreItems.vue?vue&type=script&lang=js"
export * from "./ClearAllStoreItems.vue?vue&type=script&lang=js"

import "./ClearAllStoreItems.vue?vue&type=style&index=0&id=64884da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64884da8"]])

export default __exports__